/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputCriteriaAutocompleteMultiSelectionComponent} from './input-criteria-autocomplete-multi-selection.component';
import {MultiSelectDropdownModule} from '../shared/multi-select-dropdown/multi-select-dropdown.module';
import {InputModule} from '../../../input/input.module';
import {TooltipModule} from '../../../tooltip/tooltip.module';

@NgModule({
    declarations: [
        InputCriteriaAutocompleteMultiSelectionComponent
    ],
    exports: [
        InputCriteriaAutocompleteMultiSelectionComponent
    ],
    imports: [
        CommonModule,
        MultiSelectDropdownModule,
        InputModule,
        TooltipModule
    ]
})
export class InputCriteriaAutocompleteMultiSelectionModule {
}
